/**
 * services/web-ui/src/hooks/useComplianceStats.ts
 *
 * W4-C: TanStack Query hook for cross-call compliance stats.
 * Stats change slowly so we use a 60s staleTime.
 */

import { useQuery } from "@tanstack/react-query";
import { fetchStats, type SessionStats } from "../api/voice-sessions-list";

export interface UseComplianceStatsResult {
  stats: SessionStats | null;
  isLoading: boolean;
  error: Error | null;
}

export function useComplianceStats(): UseComplianceStatsResult {
  const { data, isLoading, error } = useQuery({
    queryKey: ["voice", "sessions", "stats"],
    queryFn: () => fetchStats(),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });

  return {
    stats: data ?? null,
    isLoading,
    error: error as Error | null,
  };
}
